import * as requestFromServer from './pasoDosCrud';
import { pasoDosSlice, callTypes } from './pasoDosSlice';


const { actions } = pasoDosSlice;

export const fetchPasoDosAlUno = queryParams => async dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return await requestFromServer
        .postPasoDosAlUno(queryParams)
        .then(response => {
            const pasoDosAlUnoInformacion = response.data;
            dispatch(actions.pasoDosAlUnoFetched({ pasoDosAlUnoInformacion }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data.title || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const fetchPasoDosAlTres = queryParams => async dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return await requestFromServer
        .postPasoDosAlTres(queryParams)
        .then(response => {
            const establecimientos = response.data.ofertasSeleccionadas;
            dispatch(actions.pasoDosAlTresFetched({ establecimientos }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data.title || error.response.data.title || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const stateLimpiar = queryParams => dispatch => {
    dispatch(actions.stateLimpiar());
};